import { FieldArray } from 'formik';
import { t } from 'i18next';
import { path } from 'ramda';
import React from 'react';

import { SelectS } from '../../common';
import { CommonMultipleFieldWrap, InputWrapper } from '../companyEditS';

import AddNewFieldBtn from './addFieldBtn';

const SelectsArray = ({
  values,
  selectName,
  options,
  valuesPath,
  transKeyBase,
  renderAddNewFieldBtn,
  onChange,
  onBlur,
}) => (
  <InputWrapper width="45%" mobileWidth="100%">
    <FieldArray name={selectName}>
      {({ push, remove }) =>
        path(valuesPath, values).map((v, i) => (
          <CommonMultipleFieldWrap key={i}>
            <SelectS
              height="auto"
              closeBtnHandler={path(valuesPath, values).length !== 1 && (() => remove(i))}
              label={i === 0 && t(`companyEdit.labels.${selectName}`)}
              name={`${selectName}.${i}`}
              value={path(valuesPath, values)[i]}
              {...{ onChange, onBlur }}
            >
              <option value="">{t(`companyEdit.selectPlaceholders.${selectName}`)}</option>
              {options
                .filter((s) => !path(valuesPath, values).includes(s) || path(valuesPath, values)[i] === s)
                .map((s) => (
                  <option value={s} key={s}>
                    {transKeyBase ? t(`${transKeyBase}.${s}`) : s}
                  </option>
                ))}
            </SelectS>
            {renderAddNewFieldBtn(i) && <AddNewFieldBtn {...{ push }} />}
          </CommonMultipleFieldWrap>
        ))
      }
    </FieldArray>
  </InputWrapper>
);

export default SelectsArray;
